import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, MapPin, Phone, Clock, Truck, ShieldCheck, CreditCard, Wrench } from "lucide-react";
import { STORE_INFO, CATEGORIES } from "../mock";
import Logo from "./Logo";

const Footer = () => {
  return (
    <footer className="mt-16 bg-[#0b2960] text-neutral-200">
      {/* Trust bar */}
      <div className="bg-white border-t border-b border-neutral-200">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 divide-x divide-neutral-200">
          {[
            { icon: Truck, title: "Livraison rapide", text: "Marseille & alentours" },
            { icon: Wrench, title: "Dépannage", text: "Techniciens à domicile" },
            { icon: ShieldCheck, title: "Garantie", text: "Sur toute notre gamme" },
            { icon: CreditCard, title: "Paiement 1 fois", text: "En magasin ou livraison" },
          ].map((s, i) => (
            <div key={i} className="flex items-center gap-3 p-4 md:p-6 text-neutral-800">
              <div className="h-11 w-11 rounded-full bg-[#0b2960]/10 flex items-center justify-center text-[#0b2960]">
                <s.icon className="h-5 w-5" />
              </div>
              <div>
                <div className="font-bold text-sm">{s.title}</div>
                <div className="text-xs text-neutral-500">{s.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="mb-4">
            <Logo variant="light" size="md" showTagline={false} />
          </div>
          <p className="text-sm text-neutral-300 leading-relaxed">
            Votre spécialiste électroménager, dépannage et service à Marseille. Des grandes marques neuves et d'occasion au meilleur prix.
          </p>
          <div className="mt-3 text-[11px] text-neutral-400">SIRET : {STORE_INFO.siret}</div>
          <div className="flex items-center gap-3 mt-4">
            <a href={STORE_INFO.socials.facebook} className="h-9 w-9 rounded-full bg-white/10 hover:bg-[#e11d24] flex items-center justify-center transition-colors"><Facebook className="h-4 w-4" /></a>
            <a href={STORE_INFO.socials.instagram} className="h-9 w-9 rounded-full bg-white/10 hover:bg-[#e11d24] flex items-center justify-center transition-colors"><Instagram className="h-4 w-4" /></a>
            <a href={`mailto:${STORE_INFO.email}`} className="h-9 w-9 rounded-full bg-white/10 hover:bg-[#e11d24] flex items-center justify-center transition-colors"><Mail className="h-4 w-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="font-bold text-white mb-4 tracking-wide uppercase text-sm">Nos catégories</h4>
          <ul className="space-y-2 text-sm">
            {CATEGORIES.slice(0, 7).map((c) => (
              <li key={c.id}>
                <Link to={`/boutique?cat=${c.slug}`} className="text-neutral-300 hover:text-[#e11d24] transition-colors">{c.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-white mb-4 tracking-wide uppercase text-sm">Informations</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/magasin" className="text-neutral-300 hover:text-[#e11d24] transition-colors">Notre magasin</Link></li>
            <li><Link to="/livraison-garantie" className="text-neutral-300 hover:text-[#e11d24] transition-colors">Livraison & Garantie</Link></li>
            <li><Link to="/services" className="text-neutral-300 hover:text-[#e11d24] transition-colors">Services & Dépannage</Link></li>
            <li><Link to="/contact" className="text-neutral-300 hover:text-[#e11d24] transition-colors">Nous contacter</Link></li>
            <li><a href="#" className="text-neutral-300 hover:text-[#e11d24] transition-colors">Mentions légales</a></li>
            <li><a href="#" className="text-neutral-300 hover:text-[#e11d24] transition-colors">CGV</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-white mb-4 tracking-wide uppercase text-sm">Contactez-nous</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 mt-0.5 text-[#e11d24] shrink-0" />
              <span className="text-neutral-300">{STORE_INFO.address}</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-[#e11d24]" />
              <a href={`tel:${STORE_INFO.phone.replace(/\s/g, "")}`} className="text-neutral-300 hover:text-white">{STORE_INFO.phone}</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-[#e11d24]" />
              <a href={`mailto:${STORE_INFO.email}`} className="text-neutral-300 hover:text-white">{STORE_INFO.email}</a>
            </li>
            <li className="flex items-start gap-2">
              <Clock className="h-4 w-4 mt-0.5 text-[#e11d24] shrink-0" />
              <div className="text-neutral-300">
                <div>Lun-Ven: 09h-19h</div>
                <div>Sam: 09h-19h · Dim: Fermé</div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-neutral-400">
          <div>© {new Date().getFullYear()} EDS ELECTROMENAGER · SIRET {STORE_INFO.siret} · Tous droits réservés</div>
          <div className="flex items-center gap-4">
            <span>Marseille · Électroménager · Dépannage · Service</span>
            <Link to="/admin" className="hover:text-white opacity-60 hover:opacity-100 transition-opacity">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
